"use strict";
// authSlice.ts
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuthError = exports.setUnauthenticated = exports.setAuthenticated = exports.deleteUserRealTime = exports.editUserRealTime = exports.addUserRealTime = exports.fetchUserDocByEmail = exports.resetMyPassword = exports.resetPassword = exports.signOut = exports.signIn = exports.checkAuthChange = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var usersSlice_1 = require("../users/usersSlice");
var initialState = {
    user: null,
    currentUser: {},
    status: "idle",
    currentUserStatus: "idle",
    error: null,
};
// Check for authentication changes
exports.checkAuthChange = (0, toolkit_1.createAsyncThunk)("auth/checkAuthChange", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var session, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, supabaseClient_1.supabase.auth.getSession()];
            case 1:
                session = (_a.sent()).data.session;
                if (session === null || session === void 0 ? void 0 : session.user) {
                    thunkApi.dispatch(authSlice.actions.setAuthenticated(session.user));
                    thunkApi.dispatch((0, exports.fetchUserDocByEmail)(session === null || session === void 0 ? void 0 : session.user.email));
                    thunkApi.dispatch((0, usersSlice_1.fetchUsersInBatches)());
                }
                else {
                    thunkApi.dispatch(authSlice.actions.setUnauthenticated());
                }
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error("Error in checkAuthChange:", error_1.message);
                return [2 /*return*/, thunkApi.rejectWithValue(error_1.message)];
            case 3: return [2 /*return*/];
        }
    });
}); });
// Sign in a user
exports.signIn = (0, toolkit_1.createAsyncThunk)("auth/signIn", function (_a, thunkApi) {
    var email = _a.email, password = _a.password;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c, session, user, error, error_2;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, supabaseClient_1.supabase.auth.signInWithPassword({ email: email, password: password })];
                case 1:
                    _b = _d.sent(), _c = _b.data, session = _c.session, user = _c.user, error = _b.error;
                    if (session === null || session === void 0 ? void 0 : session.user) {
                        thunkApi.dispatch(authSlice.actions.setAuthenticated(session === null || session === void 0 ? void 0 : session.user));
                        thunkApi.dispatch((0, exports.fetchUserDocByEmail)(session === null || session === void 0 ? void 0 : session.user.email));
                    }
                    else {
                        thunkApi.dispatch(authSlice.actions.setUnauthenticated());
                    }
                    if (error) {
                        return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, user];
                case 2:
                    error_2 = _d.sent();
                    console.log({ error: error_2 });
                    return [2 /*return*/, thunkApi.rejectWithValue(error_2.message)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Sign out a user
exports.signOut = (0, toolkit_1.createAsyncThunk)("auth/signOut", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase.auth.signOut()];
            case 1:
                error = (_a.sent()).error;
                console.log({ error: error });
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/];
        }
    });
}); });
// Reset a user's password to a default value ("ida12345")
exports.resetPassword = (0, toolkit_1.createAsyncThunk)("auth/resetPassword", function (userId, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var newPassword, updateError, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                newPassword = "ida12345";
                return [4 /*yield*/, supabaseClient_1.supabase.auth.updateUser({
                        email: "".concat(userId, "@ida-org.com"),
                        password: newPassword,
                    })];
            case 1:
                updateError = (_a.sent()).error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, { userId: userId, newPassword: newPassword }];
            case 2:
                error_3 = _a.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(error_3.message)];
            case 3: return [2 /*return*/];
        }
    });
}); });
exports.resetMyPassword = (0, toolkit_1.createAsyncThunk)("auth/resetMyPassword", function (_a, thunkApi) {
    var email = _a.email, newPassword = _a.newPassword;
    return __awaiter(void 0, void 0, void 0, function () {
        var updateError, error_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, supabaseClient_1.supabase.auth.updateUser({
                            email: email,
                            password: newPassword,
                        })];
                case 1:
                    updateError = (_b.sent()).error;
                    if (updateError) {
                        return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                    }
                    return [2 /*return*/, { email: email, newPassword: newPassword }];
                case 2:
                    error_4 = _b.sent();
                    return [2 /*return*/, thunkApi.rejectWithValue(error_4.message)];
                case 3: return [2 /*return*/];
            }
        });
    });
});
// Fetch user document by ID
exports.fetchUserDocByEmail = (0, toolkit_1.createAsyncThunk)("auth/fetchUserDocByEmail", function (email, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error, error_5;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, supabaseClient_1.supabase
                        .from("users_warehouses")
                        .select("*")
                        .eq("email", email)
                        .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
            case 2:
                error_5 = _b.sent();
                return [2 /*return*/, thunkApi.rejectWithValue(error_5.message)];
            case 3: return [2 /*return*/];
        }
    });
}); });
// Real-Time Actions
var addUserRealTime = function (newUser) { return ({
    type: "users/addUserRealTime",
    payload: newUser,
}); };
exports.addUserRealTime = addUserRealTime;
var editUserRealTime = function (updatedUser) { return ({
    type: "users/editUserRealTime",
    payload: updatedUser,
}); };
exports.editUserRealTime = editUserRealTime;
var deleteUserRealTime = function (id) { return ({
    type: "users/deleteUserRealTime",
    payload: id,
}); };
exports.deleteUserRealTime = deleteUserRealTime;
var authSlice = (0, toolkit_1.createSlice)({
    name: "auth",
    initialState: initialState,
    reducers: {
        setAuthenticated: function (state, action) {
            state.user = action.payload;
            state.status = "authenticated";
            state.error = null;
        },
        setUnauthenticated: function (state) {
            state.user = null;
            state.status = "unauthenticated";
            state.error = null;
        },
        setAuthError: function (state, action) {
            state.status = "failed";
            state.error = action.payload;
        },
    },
    extraReducers: function (builder) {
        // Handle checkAuthChange
        builder
            .addCase(exports.checkAuthChange.pending, function (state) {
            state.status = "idle";
        })
            .addCase(exports.checkAuthChange.fulfilled, function (state) {
            // Status will be set by onAuthStateChange subscription
        })
            .addCase(exports.checkAuthChange.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to check authentication.";
        })
            // Handle signIn
            .addCase(exports.signIn.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.signIn.fulfilled, function (state, action) { })
            .addCase(exports.signIn.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to sign in.";
        })
            // Handle signOut
            .addCase(exports.signOut.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.signOut.fulfilled, function (state) {
            state.user = null;
            state.status = "unauthenticated";
            state.error = null;
        })
            .addCase(exports.signOut.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to sign out.";
        })
            // Handle fetchUserDocByEmail
            .addCase(exports.fetchUserDocByEmail.pending, function (state) {
            state.currentUserStatus = "loading";
        })
            .addCase(exports.fetchUserDocByEmail.fulfilled, function (state, action) {
            var user = action.payload;
            state.currentUser = user;
            state.currentUserStatus = "userDocSuccess";
            state.error = null;
        })
            .addCase(exports.fetchUserDocByEmail.rejected, function (state, action) {
            state.currentUserStatus = "failed";
            state.error = action.payload || "Failed to fetch user document.";
        })
            // Handle resetPassword
            .addCase(exports.resetPassword.pending, function (state) {
            // state.status = "loading";
        })
            .addCase(exports.resetPassword.fulfilled, function (state, action) {
            // state.status = "succeeded";
            state.error = null;
            console.log("Password for user ".concat(action.payload.userId, " has been reset"));
        })
            .addCase(exports.resetPassword.rejected, function (state, action) {
            // state.status = "failed";
            state.error = action.payload || "Failed to reset password.";
        })
            // Handle resetMyPassword
            .addCase(exports.resetMyPassword.pending, function (state) {
            // state.status = "loading";
        })
            .addCase(exports.resetMyPassword.fulfilled, function (state, action) {
            // state.status = "succeeded";
            state.error = null;
        })
            .addCase(exports.resetMyPassword.rejected, function (state, action) {
            // state.status = "failed";
            state.error = action.payload || "Failed to reset password.";
        });
    },
});
exports.setAuthenticated = (_a = authSlice.actions, _a.setAuthenticated), exports.setUnauthenticated = _a.setUnauthenticated, exports.setAuthError = _a.setAuthError;
exports.default = authSlice.reducer;
